<template>
<div class="courseChapter">

    <div class="courseInfo">

        <img :src="goodInfo.cover" width="340" height="auto" class="base-image">

        <div class="couseDetail">

            <div class="title flex">

                <div class="title-detail">{{ goodInfo.title }}</div>

                <!--   <div class="price" v-if="goodInfo.price">￥{{goodInfo.price}}</div>

              <div class="price" v-else>￥0</div>-->

            </div>

            <div class="desc  flex">

                <span>

                    <span>{{ goodInfo.hotCount }}</span>人已学习</span>

                <!--          <span v-if="payProgress==1" v-else>未购买</span>-->

                <!--            <el-button type="primary" @click="learnCourse">立即学习</el-button>-->

                <el-button type="primary" @click="learnCourse('jixu')">继续学习</el-button>

                <!--          v-if="payProgress==1"-->

                <!--          <el-button type="primary" v-else>立即购买</el-button>-->

            </div>

        </div>

    </div>

    <!-- 每次开直播的时候都要申请，还是说可以一直使用 -->

    <div class="detail">

        <router-link @click.native="goodDetailId = ''" class="chapter-title" :class="goodDetailId == '' ? 'active' : ''" :to="'/course/describe?id=' + goodInfo.id"> 课程简介

        </router-link>

        <p v-if="watchChapter.length > 0">先学习以下章节才能解锁剩余课程</p>

        <div class="chapter" v-if="watchChapter.length > 0">

            <el-collapse :value="1">

                <el-collapse-item :name="1" :key="1" title="优先打卡章节">

                    <div :class="goodDetailId == detailItem.id  ? 'active' : ''" @click.stop="watchGoodDetail({...detailItem,lastDetailSecs:0}, detailItem.id)" class="flex" v-for="(detailItem, detailIndex) of watchChapter">

                        <div class="index_box_hALSe"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">

                                <circle v-if="goodDetailId == detailItem.id" cx="6" cy="6" r="5.5" stroke="#ffffff"></circle>

                                <circle v-else cx="6" cy="6" r="5.5" stroke="#FF4D6D"></circle>

                            </svg></div>

                        <div class="lesson-type-box">

                            <i class=" el-icon-video-camera-solid"></i>

                        </div>

                        <div class="course-name"> {{ detailItem.title }} </div>

                    </div>

                </el-collapse-item>

            </el-collapse>

        </div>

        <p>课程目录</p>

        <div class="chapter">
            <el-collapse v-model="activeNames2">
                <el-collapse-item v-if="goodInfo.sellGoodGroupList.length>0" :title="item.name" :name="index" :key="index" v-for="(item, index) of goodInfo.sellGoodGroupList">
                    <div :class="!lookInfo&&goodDetailId == detailItem.id ? 'active' : ''" :key="detailIndex" @click.stop="watchGoodDetail({...detailItem,lastDetailSecs:0}, detailItem.id)" class="flex" v-for="(detailItem, detailIndex) of item.sellGoodDetailList">
                        <div class="index_box_hALSe"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle v-if="goodDetailId == detailItem.id" cx="6" cy="6" r="5.5" stroke="#ffffff"></circle>
                                <circle v-else cx="6" cy="6" r="5.5" stroke="#FF4D6D"></circle>
                            </svg></div>
                        <div class="lesson-type-box">
                            <i class=" el-icon-video-camera-solid"></i>
                        </div>
                        <div class="course-name"> {{ detailItem.title }} </div>
                    </div>

                </el-collapse-item>

                <el-collapse-item title="其他章节" v-if="goodInfo.noGroupDetailList.length>0" :name="9999">
                    <div :class="!lookInfo&&goodDetailId == item.id ? 'active' : ''" @click.stop="watchGoodDetail({...item,lastDetailSecs:0}, item.id)" :key="index" class="flex " v-for="(item, index) of goodInfo.noGroupDetailList">
                        <div class="index_box_hALSe"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle v-if="!lookInfo&&goodDetailId == item.id" cx="6" cy="6" r="5.5" stroke="#ffffff"></circle>
                                <circle v-else cx="6" cy="6" r="5.5" stroke="#FF4D6D"></circle>
                            </svg></div>
                        <div class="lesson-type-box">
                            <i class=" el-icon-video-camera-solid"></i>
                        </div>
                        <div class="course-name"> {{ item.title }} </div>
                    </div>
                </el-collapse-item>
            </el-collapse>

        </div>

    </div>

</div>
</template>

<script>
import {
    getOrder,
    getOrderGive,
    createGoodImageText
} from "@/api/order.js"
import {
    accAdd
} from "../../../utils";
import {
    getWatchSecsByOrderId
} from "@/api/commerce/study.js"
export default {
    // ,'goodDetailId'
    props: ['goodInfo', 'payProgress', 'orderInfo', 'giveOrder', 'lookInfo', 'watchChapter', 'detailId'],
    data() {
        return {
            goodDetailId: '', //当前选中的章节内容
            title: '', //课程标题
            activeNames: 0,
            activeNames2: [], //当前是否开启
        }
    },
    watch: {
        detailId() {
            this.goodDetailId = this.detailId;
            this.activeNames2 = 0;
        },
        goodInfo() {
            let goodInfo = this.goodInfo
            if (goodInfo.buyCount && goodInfo.mockBuyCount) { //已学习人数
                this.goodInfo.hotCount = accAdd(goodInfo.buyCount, goodInfo.mockBuyCount)
            } else if (goodInfo.buyCount) {
                this.goodInfo.hotCount = goodInfo.buyCount
            } else if (goodInfo.mockBuyCount) {
                this.goodInfo.hotCount = goodInfo.mockBuyCount
            } else {
                this.goodInfo.hotCount = 0
            }

            this.activeNames2 = []
            if (this.goodInfo.title.length > 12) {
                this.title = this.goodInfo.title.slice(0, 12) + '...'
            } else {
                this.title = this.goodInfo.title
            }
            let sellGoodGroupList = this.goodInfo.sellGoodGroupList
            // 打卡章节情况
            if (this.watchChapter.length > 0) {
                if (this.orderInfo.lastDetailId) {
                    this.goodDetailId = this.orderInfo.lastDetailId;
                } else {
                    this.goodDetailId = this.watchChapter[0].id;
                }
                // 从上次观看记录观看
                this.watchGoodDetail({
                    id: this.goodDetailId,
                    lastDetailSecs: this.orderInfo.lastDetailId == this.goodDetailId ? this.orderInfo.lastDetailSecs : 0
                }, this.goodDetailId)

            } else {
                if (sellGoodGroupList.length > 0) {
                    sellGoodGroupList.map((item, index) => {
                        this.activeNames2.push(index)
                        if (index == sellGoodGroupList.length - 1) {
                            this.activeNames2.push(9999)
                            this.activeNames = 9999
                        }
                    })
                } else {
                    this.activeNames2.push(9999)
                }
            }
        }
    },
    mounted() {
        if (this.goodInfo) {
            if (this.goodInfo.title.length > 12) {
                this.title = this.goodInfo.title.slice(0, 12) + '...'
            } else {
                this.title = this.goodInfo.title
            }
        }
        this.goodDetailId = '';
    },
    methods: {

        /**
         * 修改纯图文订单状态，并记录对应的章节内容
         * @param orderId  订单号
         * @param goodId  商品ID
         * @param goodDetailId  商品详情id
         */
        async createGoodImageText(goodDetailId) {
            let res = await createGoodImageText({
                goodId: this.goodInfo.id,
                orderId: this.orderInfo.id,
                goodDetailId
            })
        },

        //课程详情
        async getOrder() {
            var orderRes;
            if (this.giveOrder != 1) {
                orderRes = await getOrder({
                    id: this.orderInfo.id
                })
            } else {
                orderRes = await getOrderGive(this.orderInfo.id)
            }
            if (orderRes.result == 'true') {
                let orderInfo = orderRes.data;
                this.goodDetailId = orderInfo.lastDetailId;
                this.goodInfo.sellGoodDetailList.map((item, index) => { //判断当前播放是哪一个
                    if (this.goodDetailId == item.id) {
                        item.study = true;
                        this.watchGoodDetail(item, item.id)
                        this.$emit('chooseCourseDetails', item)
                        if (this.$route.name !== 'courseWatch') {
                            this.$router.push({
                                name: 'courseWatch',
                                params: {
                                    detail: item,
                                    goodInfo: this.goodInfo,
                                    study: true
                                }
                            })
                        }
                    } else {

                    }
                })
            }
        },
        //  去学习||继续学习
        learnCourse(type) {
            if (type == 'jixu' && this.orderInfo.lastDetailId) { //继续学习 从订单里获取数据
                this.getOrder()
            } else {
                if (this.watchChapter.length > 0) {
                    this.goodDetailId = this.watchChapter[0].id;
                    this.$emit('chooseCourseDetails', this.watchChapter[0])
                    if (this.$route.name !== 'courseWatch') {
                        this.$router.push({
                            name: 'courseWatch',
                            params: {
                                detail: this.watchChapter[0],
                                goodInfo: this.goodInfo
                            }
                        })
                    }
                }
                if (this.goodInfo.sellGoodGroupList && this.goodInfo.sellGoodGroupList.length > 0) {
                    var sellGoodGroupList = this.goodInfo.sellGoodGroupList; //第一个分组
                    var sellGoodDetailList = sellGoodGroupList[0].sellGoodDetailList
                    this.goodDetailId = sellGoodDetailList[0].id
                    this.$emit('chooseCourseDetails', sellGoodDetailList[0])
                    if (this.$route.name !== 'courseWatch') {
                        this.$router.push({
                            name: 'courseWatch',
                            params: {
                                detail: sellGoodDetailList[0],
                                goodInfo: this.goodInfo
                            }
                        })
                    }
                } else {
                    this.goodDetailId = this.goodInfo.noGroupDetailList[0].id
                    if (this.$route.name !== 'courseWatch') {
                        this.$router.push({
                            name: 'courseWatch',
                            params: {
                                detail: this.goodInfo.noGroupDetailList[0],
                                goodInfo: this.goodInfo
                            }
                        })
                    }
                    this.$emit('chooseCourseDetails', this.goodInfo.noGroupDetailList[0])
                }
            }
        },
        //观看
        async watchGoodDetail(detail, id) {
            // 是否处于打卡章节内
            let returnIndex = this.watchChapter.findIndex(($v) => {
                return $v.id == id;
            });
            let orderId = this.orderInfo.id;
            let res = await getWatchSecsByOrderId(orderId);
            if (res.data < this.lookInfo.totalSecs && returnIndex == -1) {
                this.$message.error('请观看完打卡章节后才可解锁此章节')
                return false
            }
            if (this.orderInfo.refundRuleCode == 5) {
                this.createGoodImageText(id)
            }
            this.goodDetailId = id;
            // 从上次学习进度继续开始
            let lastDetailSecs = detail.lastDetailSecs;
            if (returnIndex > -1) {
                detail = this.goodInfo.sellGoodDetailList.find(($v) => {
                    return $v.id == id;
                });
            }
            // 从上次学习进度继续开始
            detail.lastDetailSecs = lastDetailSecs;
            this.$emit('chooseCourseDetails', detail)
            if (this.$route.name !== 'courseWatch') {
                this.$router.push({
                    name: 'courseWatch',
                    params: {
                        detail,
                        goodInfo: this.goodInfo
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.detail ::v-deep {
    padding: 20px 32px;

    .noGroupon {
        .el-collapse-item__header {
            display: none;
        }
    }

    .router-link-active {
        background: #FF4D6D;
        color: #fff;
    }

    .active {
        background: #FF4D6D !important;
        color: #fff !important;

        .el-icon-video-camera-solid {
            color: #fff !important;
        }
    }

    .el-collapse {
        svg {
            width: 20px;
        }

        .el-icon-video-camera-solid {
            font-size: 20px;
            margin: 0 10px;
            color: #FF4D6D;
        }

        .course-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .el-collapse-item__header {
            padding-left: 8px;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            height: 46px;
            padding-top: 20upx; // overflow: hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;
        }

        .el-collapse-item__content {
            padding-bottom: 0;

            &>div {
                height: 48px;
                margin: 4px 0;
                align-items: center;
                padding: 0 16px;
                border-radius: 4px;
                cursor: pointer;

                &:hover {
                    background: #f5f5f5;
                }
            }
        }
    }

    &>p {
        margin-bottom: 4px;
        padding-left: 8px;
        color: #999;
        font-size: 12px;
        line-height: 20px;
        margin-bottom: 10px;
    }

    .chapter-title {
        display: block;
        margin-bottom: 8px;
        padding-left: 8px;
        font-weight: 600;
        font-size: 16px;
        line-height: 48px;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
            background: #f5f5f5;
        }

        &.active {
            background: #FF4D6D;
            color: #fff;
        }
    }
}

.courseChapter {
    text-align: left;
    height: calc(100vh - 64px);
    overflow-y: auto;

    .courseInfo {
        padding: 24px 40px 20px;
        border-bottom: 1px solid #ebebeb;

        .chapter {}

        .couseDetail {
            .title {
                margin: 16px 0 12px;
                color: #333;
                font-weight: 600;
                font-size: 18px;
                line-height: 26px;

                .title-detail {
                    width: 350px;
                    padding-right: 15px;
                }
            }

            .desc {
                /*justify-content: flex-end;*/
                justify-content: space-between;
                align-items: center;

                .price {
                    align-items: flex-end;
                    font-size: 16px;
                    color: #f00;
                    /*font-weight: bold;*/
                }

                span {
                    /*font-size: 16px;*/
                    color: #666;
                    font-size: 14px;
                    /*line-height: 18px;*/
                }

                button {
                    background-color: #FF4D6D !important;
                    border-color: #FF4D6D !important;
                    width: 100px;
                    line-height: 13px;
                }
            }
        }

        img {
            object-position: top;
            vertical-align: top;
            object-fit: cover;
            border-radius: 4px;
            width: 340px;
            height: 192px;
        }
    }
}
</style>
